import { decamelize } from 'helpers/camelize';
import {
  fetchWrapper,
  handleResponse,
  hcUrl,
  buildOpts,
  transformMenuResponse,
  transformMenuMealResponse,
  objectToQueryString,
} from 'services/RequestService/helpers';

export const getMenu = async ({ params: { menuSlug } }) => {
  const response = await fetchWrapper(
    hcUrl(`/menus/${menuSlug}?remove_modal_meals=true&remove_meal_details=true`),
    buildOpts()
  );
  return handleResponse(response, transformMenuResponse);
};

export const getMenuCategories = async ({ params }) => {
  const response = await fetchWrapper(
    hcUrl(`/menu_categories?${objectToQueryString(decamelize(params, true))}`),
    buildOpts({
      method: 'GET',
    })
  );
  return handleResponse(response);
};

export const getMenuMeal = async ({ params: { menuSlug, mealId } }) => {
  const response = await fetchWrapper(
    hcUrl(`/menu_meals/${mealId}?menu_id=${menuSlug}`),
    buildOpts()
  );
  return handleResponse(response, transformMenuMealResponse);
};
